import React, { FC, useEffect, useState } from 'react'
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { AppDispatch } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { getAllStock, payday, selectAllStock, selectMMExist, selectStockError, selectStockStatus } from '../../../redux/Slices/StockSlice';
import { selectGameId, selectRoleJoinId } from '../../../redux/Slices/JoinGameSlice';
import { selectRoleId } from '../../../redux/Slices/SelectRoleSlice';
import { updateGameOrderBook } from '../../../redux/Slices/GameSettingSlice';
import { clearRespondMarketMayhem, selectRespondMarketMayhem } from '../../../redux/Slices/MarketMayhemSlice';
import { getMarketMayhem } from '../../../redux/Slices/MarketMayhemSlice';
import Loader from '../../atoms/Loader/Loader';
import Button from '../../atoms/Button/Button';
import StockPricesContainer from '../../molecules/StockPricesContainer/StockPricesContainer';
import RefreshButton from '../../atoms/RefreshButton/RefreshButton';
import { confirmModalProps } from '../../../app/utils/interface/confirm';
import ConfirmModal from '../../atoms/confirmation-modal/confirmation-modal';
import HelpContainer from '../../molecules/HelpContainer/HelpContainer';
import OutsideClickHandler from 'react-outside-click-handler';
import { IoMdHelpCircleOutline, IoMdInformationCircleOutline } from "react-icons/io";
import './StockPricesScreen.scss';
import sendFirebaseEvent from '../../../app/firebase/sendFirebaseEvent';
import { selectGetUser } from '../../../redux/Slices/authSlice';
import { image } from '../../../app/utils/common/image';

interface StockPricesScreenProps {
    handleInitiateTradeButton: any,
    orderBookStatus: number,
    secondsLeft: number | null,
    loadingTrade: boolean,
    setLoadingTrade: React.Dispatch<React.SetStateAction<boolean>>,
    helpShow: boolean,
    setHelpShow: React.Dispatch<React.SetStateAction<boolean>>,
    handleClose: VoidFunction
}

const StockPricesScreen: FC<StockPricesScreenProps> = (props) => {
    const { handleInitiateTradeButton, orderBookStatus, secondsLeft, loadingTrade, helpShow, setHelpShow, handleClose } = props
    const [loading, setLoading] = useState<boolean>(false);
    const [confirmModal, setConfirmModal] = useState<boolean>(false);

    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch();
    const stockPrices = useSelector(selectAllStock);
    const stockPricesStatus = useSelector(selectStockStatus);
    const stockPricesError = useSelector(selectStockError);
    const gameId = useSelector(selectGameId);
    const roleId = useSelector(selectRoleId);
    const joinRoleId = useSelector(selectRoleJoinId);
    const stockMMExist = useSelector(selectMMExist);
    const respondMessage = useSelector(selectRespondMarketMayhem);
    const currentUser = useSelector(selectGetUser);
    const hasActiveMarketMayhem = stockMMExist === 1 || stockMMExist === '1' || stockMMExist === true;
    const [investorSubmittedCurrentMM, setInvestorSubmittedCurrentMM] = useState<boolean>(false);

    const shouldShowButtons = () => {
        const role = joinRoleId !== undefined ? joinRoleId : roleId;  // Use roleId if joinRoleId is undefined
        return role !== 2;
    };
    const roleIdStock = joinRoleId !== undefined ? joinRoleId : roleId;
    // useEffect(() => {
    //     dispatch(getGameSetting(gameId));
    // }, []);

    useEffect(() => {
        if (gameId) {
            dispatch(getAllStock(gameId)); // Fetch stock prices on screen load or gameId change
        }
        dispatch(updateGameOrderBook({ gameId, orderbook_status: orderBookStatus }))
    }, [dispatch, gameId]);

    useEffect(() => {
        if (!hasActiveMarketMayhem && respondMessage) {
            dispatch(clearRespondMarketMayhem());
        }
    }, [hasActiveMarketMayhem, respondMessage, dispatch]);

    useEffect(() => {
        if (roleIdStock !== 2 || !hasActiveMarketMayhem || !gameId) {
            setInvestorSubmittedCurrentMM(false);
            return;
        }

        dispatch(getMarketMayhem(gameId))
            .unwrap()
            .then((response: any) => {
                const respondedPlayers = response?.data?.responded_players || [];
                const currentUserId = currentUser?.id || currentUser?.user_id;
                const hasSubmitted = respondedPlayers.some((player: any) => {
                    const playerId = player?.user_id || player?.id || player;
                    return String(playerId) === String(currentUserId);
                });
                setInvestorSubmittedCurrentMM(hasSubmitted);
            })
            .catch(() => {
                setInvestorSubmittedCurrentMM(false);
            });
    }, [dispatch, roleIdStock, hasActiveMarketMayhem, gameId, currentUser?.id, currentUser?.user_id, respondMessage]);

    // Stock Prices status loading state
    useEffect(() => {
        if (stockPricesStatus === 'loading') {
            setLoading(true);
        } else if (stockPricesStatus === 'succeeded') {
            setLoading(false);
        } else if (stockPricesStatus === 'failed') {
            setLoading(false);
            if (stockPricesError?.error?.message === 'Game already completed.') {
                navigate('/profile')
            }
        }
    }, [stockPricesStatus]);

    const handlePaydayButton = () => {
        setConfirmModal(false)
        setLoading(true);
        dispatch(payday(gameId)).unwrap().then((response) => {
            setLoading(false)
            message.success(response.message);
            dispatch(getAllStock(gameId))
        }).catch((error) => {
            console.error("Payday error:", error);
        });
        setLoading(false);
    };

    const handleStockClick = (stock: any) => {
        if (shouldShowButtons()) {
            navigate('/price-updates', { state: { stock } }); // Pass stock details
        }
    };

    const updateInvestorMarketMayhemSubmissionStatus = (marketMayhemResponse: any) => {
        const respondedPlayers = marketMayhemResponse?.data?.responded_players || [];
        const currentUserId = currentUser?.id || currentUser?.user_id;
        const hasSubmitted = respondedPlayers.some((player: any) => {
            const playerId = player?.user_id || player?.id || player;
            return String(playerId) === String(currentUserId);
        });
        setInvestorSubmittedCurrentMM(hasSubmitted);
    };

    // Handle Refresh Button to reload stock data
    const handleRefreshButton = () => {
        setLoading(true);
        dispatch(getAllStock(gameId))
            .unwrap()
            .then((stockResponse: any) => {
                const refreshedMMExist = stockResponse?.data?.is_mm_exist;
                const hasRefreshedMarketMayhem =
                    refreshedMMExist === 1 || refreshedMMExist === '1' || refreshedMMExist === true;

                if (roleIdStock === 2 && hasRefreshedMarketMayhem && gameId) {
                    return dispatch(getMarketMayhem(gameId))
                        .unwrap()
                        .then((marketMayhemResponse: any) => {
                            updateInvestorMarketMayhemSubmissionStatus(marketMayhemResponse);
                        })
                        .catch(() => {
                            setInvestorSubmittedCurrentMM(false);
                        });
                }

                setInvestorSubmittedCurrentMM(false);
            })
            .catch(() => {
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const confirmModalProps: confirmModalProps = {
        text: "Are you sure you want to give payday?",
        confirmModal,
        setConfirmModal,
        buttons: ['Yes', 'No'],
        onPressPositive: handlePaydayButton,
        onPressNegative: () => { setConfirmModal(false) }
    };

    return (
        <div className='login-container padding-bottom'>
            <div className='account-heading'>
                {/* <BackButton onClick={handleBackButton} /> */}
                <div className='purchase-btn-container'>
                    <img src={image.PURCHASE} className='purchase-btn' onClick={() => { window.open('https://joyjuncture.com', "__blank") }} />
                </div>
                <RefreshButton onClick={handleRefreshButton} />
            </div>
            <div className='timer-heading'>
                {/* <div className='' onClick={() => { navigate('/account-details') }}>profile</div> */}
                <div className='colorHeading-bckbtn portfolio-heading portfolio-text'>
                    <div className='font-bagel'>{roleIdStock === 2 ? 'Market Monitor' : 'Monitor & Action hub'}</div>
                    <div className="get-help-addOn-hover" style={{ paddingTop: "7px", marginTop: "0px", paddingLeft: "3px" }}>
                        <div className="help-image-logo" > <IoMdInformationCircleOutline cursor='pointer' /></div>
                        {roleIdStock !== 2 ? <div className="get-help-add-on-hover-hub">View and update stock prices, start trade phase, credit salaries, create Market Mayhem voting list, and see the leaderboard whenever required</div> : <div className="get-help-add-on-hover-market">View real-time stock prices of all companies
                        </div>}
                    </div>
                </div>
                {secondsLeft && secondsLeft > 0 && <div className='seconds-left'>{secondsLeft} Sec</div>}
            </div>
            <div className='flex stocks-container'>
                <div className='flex stockContainer' style={{ position: "relative" }}>
                    <div className='help-btn help-trade-btn' onClick={() => { setHelpShow(!helpShow); sendFirebaseEvent('help_button', 'user_action', 'help_button', "Help Button Clicked") }}>
                        <IoMdHelpCircleOutline color='#fff' size={28} cursor={'pointer'} />
                    </div>

                    {helpShow && <OutsideClickHandler onOutsideClick={handleClose}>
                        <HelpContainer setHelpShow={setHelpShow} />
                    </OutsideClickHandler>}
                    {/* <div className='colorHeading-bckbtn font-bagel portfolio-heading' style={{ fontSize: "45px" }}>Stock Prices</div> */}
                    <div className='flex login-upper-container stock-setup-container'>

                        <div className='border-blue'>
                            <div className='border-dark-blue'>
                                <div className='border-orange'>
                                    <div className='border-yellow'>
                                        <div className='border-inner-blue'>
                                            <div className='stock-dimension flex'>
                                                {!loading ? <StockPricesContainer stockPrices={stockPrices} handleStockClick={handleStockClick} /> : <div>
                                                    <Loader height='250px' /></div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {shouldShowButtons() && <div className='stock-prices-btns'>
                            {orderBookStatus === 0 && <Button buttonTitle='Trade Phase' onClick={handleInitiateTradeButton} className={'trade-width-button'} />}
                            {orderBookStatus === 1 && <Button buttonTitle={`${!loadingTrade ? `${secondsLeft} Sec` : "..."}`} onClick={() => { }} className={'trade-width-button'} />}
                            <Button buttonTitle='Payday' onClick={() => { setConfirmModal(true); sendFirebaseEvent('payday_button', 'user_action', 'payday_button', "Payday Button Clicked") }} className={'trade-width-button'} />
                            <Button buttonTitle='Showdown' onClick={() => { navigate('/portfolio-showdown'); sendFirebaseEvent('showdown_button', 'user_action', 'showdown_button', "ShowDown Button Clicked") }} className={'trade-width-button'} />
                        </div>}
                        {
                            (roleIdStock === 1 || roleIdStock === 3) &&
                            <div className='market-btn'>
                                <Button
                                    buttonTitle='Market Mayhem'
                                    onClick={() => { navigate('/market-mayhem'); sendFirebaseEvent('market_mayhem_button', 'user_action', 'market_mayhem_button', "Market Mayhem Button Clicked") }}
                                    className='market-width-button'
                                />
                            </div>

                        }
                        {(roleIdStock === 2) && hasActiveMarketMayhem && !investorSubmittedCurrentMM &&
                            < div className='market-btn'>
                                <Button
                                    buttonTitle='Market Mayhem'
                                    onClick={() => { navigate('/market-mayhem'); sendFirebaseEvent('market_mayhem_button', 'user_action', 'market_mayhem_button', "Market Mayhem Button Clicked") }}
                                    className='market-width-button'
                                />
                            </div>
                        }

                    </div>
                </div>
            </div>
            {confirmModal && <ConfirmModal confirmModalProps={confirmModalProps} />}
        </div >
    )
}

export default StockPricesScreen